import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { DateTime } from '../datetime/datetime';
import { FormGroup } from 'shared-components';
import { useGetEnquiryQuery, useUpdateEnquiryMutation } from './enquiries.api';
import styles from './enquiry.module.css';
import { EnquiryStatus } from '@topshots/core-models';
import { Card, CardContent } from 'shared-components';
import { Label } from 'shared-components';
import { Input } from 'shared-components';
import { FormLayout } from 'shared-components';
import { TextArea } from 'shared-components';
import { PageTitle } from 'shared-components';
import Routes from '../../app/routes';

export const Enquiry = () => {
  const { id } = useParams<{
    id: string;
  }>();
  const [update] = useUpdateEnquiryMutation();
  const { data, isFetching, isLoading } = useGetEnquiryQuery(id ?? '');
  if (isLoading || isFetching || !data) {
    return <p>Loading...</p>;
  }
  return (
    <>
      <PageTitle
        title={`Enquiry from ${data?.name}`}
        crumbs={[
          { display: Routes.DASHBOARD.title, link: Routes.DASHBOARD.link },
          { display: Routes.ENQUIRIES.title, link: Routes.ENQUIRIES.link },
          {
            display: id ?? '',
            link: `${Routes.ENQUIRIES.link}/${id}`,
          },
        ]}
        onAction={async (action) => {
          switch (action) {
            case 'mark-complete':
              await update({
                id: id as string,
                data: {
                  status: EnquiryStatus.Closed,
                },
              });
              toast.success('Enquiry marked as closed');
              break;
          }
        }}
        furtherActions={[
          ...(data.status !== EnquiryStatus.Closed
            ? [{ value: 'mark-complete', display: 'Mark as closed' }]
            : []),
        ]}
      />
      <Card>
        <CardContent>
          <FormLayout className={styles.enquiryForm}>
            <FormGroup className={styles.submitted}>
              <Label htmlFor="submitted">Submitted</Label>
              <p>
                <DateTime d={data.created_on} />
              </p>
            </FormGroup>
            <FormGroup className={styles.status}>
              <Label htmlFor="status">Status</Label>
              <Input
                readOnly
                disabled
                type="text"
                id="status"
                value={data.status}
              />
            </FormGroup>
            <FormGroup className={styles.name}>
              <Label htmlFor="name">Name</Label>
              <Input
                readOnly
                disabled
                type="text"
                id="name"
                value={data.name}
              />
            </FormGroup>
            <FormGroup className={styles.phone}>
              <Label htmlFor="phone">Phone</Label>
              <Input
                readOnly
                disabled
                type="text"
                id="phone"
                value={data.phone}
              />
            </FormGroup>
            <FormGroup className={styles.email}>
              <Label htmlFor="email">Email</Label>
              <Input
                readOnly
                disabled
                type="text"
                id="email"
                value={data.email}
              />
            </FormGroup>
            <FormGroup className={styles.message}>
              <Label htmlFor="message">Message</Label>
              <TextArea readOnly disabled id="message" value={data.message} />
            </FormGroup>
          </FormLayout>
        </CardContent>
      </Card>
    </>
  );
};
